export default __webpack_public_path__ + "static/media/refugeecamp.c9ea20b4.mp4";